import React, { useState } from 'react';
import PackageList from '../components/packages/PackageList';
import PackageForm from '../components/packages/PackageForm';
import PatientPackageManager from '../components/packages/PatientPackageManager';

const PackageManagement = () => {
  const [currentView, setCurrentView] = useState('list'); // 'list', 'form', 'patient'
  const [editingPackage, setEditingPackage] = useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null);

  const handleCreatePackage = () => {
    setEditingPackage(null);
    setCurrentView('form');
  };

  const handleEditPackage = (packageData) => {
    setEditingPackage(packageData);
    setCurrentView('form');
  };

  const handleSavePackage = (savedPackage) => {
    // Package saved successfully, return to list
    setCurrentView('list');
    setEditingPackage(null);
  };

  const handleCancelForm = () => {
    setCurrentView('list');
    setEditingPackage(null);
  };

  const handleManagePatientPackages = (patientId) => {
    setSelectedPatientId(patientId);
    setCurrentView('patient');
  };

  const handleClosePatientManager = () => {
    setCurrentView('list');
    setSelectedPatientId(null);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {currentView === 'list' && (
        <PackageList
          onCreatePackage={handleCreatePackage}
          onEditPackage={handleEditPackage}
          onManagePatientPackages={handleManagePatientPackages}
        />
      )}

      {currentView === 'form' && (
        <PackageForm
          package={editingPackage}
          onSave={handleSavePackage}
          onCancel={handleCancelForm}
        />
      )}

      {currentView === 'patient' && selectedPatientId && (
        <PatientPackageManager
          patientId={selectedPatientId}
          onClose={handleClosePatientManager}
        />
      )}
    </div>
  );
};

export default PackageManagement;